/** @format */

import {StatState} from 'types';

import {StatsFromQuery, TokenFromQuery} from '../types';

const getTokenStatus = (
  stats: ReadonlyArray<StatsFromQuery>,
  token?: TokenFromQuery,
): StatState => {
  return stats.find(stat => stat.platform === token?.provider)?.state || 'NEW';
};

export {getTokenStatus};
